export default "__VITE_ASSET__Bth9zs7N__"